module.exports = __webpack_public_path__ + "static/media/phone.abe281b9.svg";